export default "__VITE_ASSET__Djqy2xSU__"